import moment from 'moment-timezone'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getDays = (days, showAll = false) => {
  if (days.length === 7 && !showAll) return 'all days'
  if (!showAll && days.length === 5 && days[0] === 'monday' && days[4] === 'friday') return 'weekdays'

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  days = days.map((day) => day[0].toUpperCase() + day.slice(1))
  return days.join('; ')
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAddressStringFromAddressObject = (addressObject) => {
  const { City, CountryCode, StateCode, StreetAddress1, StreetAddress2, Zip } = addressObject
  return `${StreetAddress1}, ${
    StreetAddress2 ? `${StreetAddress2}, ` : ' '
  }${City}, ${StateCode} ${Zip}, ${CountryCode}`
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getAgeByDate = (dateString) => moment().diff(dateString, 'years')

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const repeatsInfoRowsGenerator = (scheduleInfo) => {
  switch (scheduleInfo.RecurringType) {
    case 'daily':
      return `Repeats daily`
    case 'weekly':
      return `Repeats weekly`

    default:
      break
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getTimeOptionsList = (zoneAbbr, interval) => {
  const times = [] // time array
  let tt = 0 // start time
  const ap = ['am', 'pm']
  for (let i = 0; tt < 24 * 60; i += 1) {
    const hh = Math.floor(tt / 60)
    const mm = tt % 60
    const hoursView = `0${hh % 12}`.endsWith('00') ? '12' : `0${hh % 12}`.slice(-2)
    times[i] = `${hoursView}:${`0${mm}`.slice(-2)}${ap[Math.floor(hh / 12)]}${zoneAbbr ? ` (${zoneAbbr})` : ''}`
    tt += interval || 15
  }
  return times
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getTimeOptionsListHours = (zoneAbbr, selectedDate, timeZone = null) => {
  const times = [`All day${zoneAbbr ? ` (${zoneAbbr})` : ''}`]
  let startHour = 0

  // Determine the timezone based on the passed timeZone or default to the system's local timezone
  const timezoneToUse = timeZone || moment.tz.zone(zoneAbbr)?.name || moment.tz.guess()

  // Current date and time in the determined timezone
  const now = moment.tz(timezoneToUse)
  const selectedDay = moment.tz(selectedDate, 'dddd MMM D YYYY', timezoneToUse) // Parse the selected date with the same timezone

  // Check if the selected day is today in the given timezone
  const isToday = selectedDay.isSame(now, 'day')

  if (isToday) {
    startHour = now.hours() // Start from the current hour
  }

  // Generate hourly time slots from the starting hour
  while (startHour < 24) {
    const formattedHourStart = `${
      startHour === 0 ? '12'
      : startHour > 12 ? startHour - 12
      : startHour
    }:00${startHour >= 12 ? 'pm' : 'am'}`

    const endHour = startHour + 1
    const formattedHourEnd =
      endHour === 24 ? '12:00am' : (
        `${
          endHour === 12 ? '12'
          : endHour > 12 ? endHour - 12
          : endHour
        }:00${endHour >= 12 ? 'pm' : 'am'}`
      )

    times.push(`${formattedHourStart} - ${formattedHourEnd}${zoneAbbr ? ` (${zoneAbbr})` : ''}`)
    startHour += 1
  }

  return times
}

/**
 * Finds the closest time option from the list based on the current time.
 * If two options are equally close, the earlier one is chosen.
 * @param {string[]} options - Array of time strings in 'hh:mmA (Zone)' format.
 * @param {string} timeZone - Timezone string (e.g., 'PST').
 * @returns {string} The closest time option.
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const findClosestTime = (options, timeZone) => {
  const now = moment().tz(timeZone)
  let closestTime = options[0]
  let smallestDiff = Infinity

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  options.forEach((option) => {
    // Extract the time part before the zone
    const timePart = option.split(' ')[0]
    const optionTime = moment.tz(timePart, 'hh:mma', timeZone)

    // Calculate the absolute difference in minutes
    const diff = Math.abs(optionTime.diff(now, 'minutes'))

    if (diff < smallestDiff) {
      smallestDiff = diff
      closestTime = option
    }
  })

  return closestTime
}
